import script from "./Income.vue?vue&type=script&setup=true&lang=js"
export * from "./Income.vue?vue&type=script&setup=true&lang=js"

import "./Income.vue?vue&type=style&index=0&id=7e3c404e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3c404e"]])

export default __exports__